import { render, staticRenderFns } from "./platDisplayWidge.vue?vue&type=template&id=2fae87a4&scoped=true"
import script from "./platDisplayWidge.vue?vue&type=script&lang=js"
export * from "./platDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./platDisplayWidge.vue?vue&type=style&index=0&id=2fae87a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae87a4",
  null
  
)

export default component.exports